import posthog from 'posthog-js';

// Initialize PostHog
if (typeof window !== 'undefined') {
  const apiKey = import.meta.env.VITE_POSTHOG_API_KEY;
  const apiHost = import.meta.env.VITE_POSTHOG_HOST;

  if (!apiKey) {
    console.warn('PostHog API key is not set. Analytics will not be tracked.');

    // In development, create a mock PostHog for testing
    if (import.meta.env.DEV) {
      console.log('🔍 PostHog Debug Mode: Events will be logged to console');

      // Override posthog.capture to log to console
      const originalCapture = posthog.capture.bind(posthog);
      posthog.capture = (eventName: string, properties?: Record<string, any>) => {
        console.log(`[PostHog Event] ${eventName}`, properties || {});
        return originalCapture(eventName, properties);
      };
    }
  } else {
    posthog.init(apiKey, {
      api_host: apiHost,
      persistence: 'localStorage+cookie',
      capture_pageview: true,
      capture_pageleave: true,
      loaded: (posthog) => {
        if (import.meta.env.DEV) {
          posthog.debug();
        }
        // You can call posthog.identify() here if you have user identification
      }
    });
  }
}

export default posthog; 